(() => {
  const clean = value => value.replace(/\s+/g, ' ').trim();
  const normalize = value => clean(value).toLowerCase().replace(/[:–—-]+$/g, '').trim();
  const groupFor = (label, context) => {
    const key = normalize(label);
    const section = normalize(context);
    if (/wasserdicht|wasserbest|water resist/.test(key)) return 'water';
    if (/gehäuse|zifferblatt|glas|durchmesser|höhe|dicke|anzeige|display/.test(key)) return 'case';
    if (/armband|bandmaterial|bandfarbe|bandbreite|bandumfang|bandlänge|schließe|verschluss|werk|quarz|kaliber|kalibre|gangreserve|funktion|akk|batterie/.test(key)) return 'movement';
    if (/gehäuse|zifferblatt|maße|materialien/.test(section)) return 'case';
    if (/armband|uhrwerk|technisch|funktion/.test(section)) return 'movement';
    return 'other';
  };
  const enhance = root => {
    if (root.dataset.enhanced) return;
    const source = root.querySelector('[data-watch-source]');
    if (!source) return;
    const labels = JSON.parse(root.querySelector('[data-watch-labels]').textContent);
    Object.keys(labels).forEach(key => {
      if (typeof labels[key] === 'string') labels[key] = labels[key].replace(/&amp;/g, '&');
    });
    const rows = {case: [], movement: [], water: [], other: []};
    const notes = [];
    const seen = new Set();
    let context = '';
    let handled = 0;
    const addRow = (label, value, section) => {
      label = clean(label).replace(/:$/, '').trim();
      value = clean(value);
      if (!label || !value) return false;
      const key = `${normalize(section)}|${normalize(label)}|${value}`;
      if (!seen.has(key)) {
        seen.add(key);
        let displayLabel = label;
        if (/^(material|farbe|breite|länge|typ|form|oberfläche|oberflächenveredelung|optik)$/i.test(label) && section) displayLabel = `${section} · ${label}`;
        rows[groupFor(label, section)].push({label:displayLabel, original:label, value, context:section});
      }
      handled++;
      return true;
    };
    const visit = node => {
      if (node.nodeType !== 1) return;
      if (node.matches('.etp-product-intro') && source.querySelector('.etp-product-details')) return;
      if (node.matches('h1,h2,h3,h4,h5,h6')) {
        context = clean(node.textContent);
        return;
      }
      if (node.matches('table')) {
        node.querySelectorAll('tr').forEach(tr => {
          const cells = [...tr.querySelectorAll('th,td')];
          if (cells.length === 2) addRow(cells[0].textContent, cells[1].textContent, context);
          else notes.push(tr.textContent);
        });
        return;
      }
      if (node.matches('p,li')) {
        if (node.querySelector(':scope > br')) {
          let segment = document.createElement('p');
          [...node.childNodes].forEach(child => {
            if (child.nodeName === 'BR') {visit(segment);segment=document.createElement('p');}
            else segment.append(child.cloneNode(true));
          });
          visit(segment);return;
        }
        const text = clean(node.textContent).replace(/^•\s*/, '');
        if (!text) return;
        const strong = node.querySelector('strong,b');
        const label = strong && clean(strong.textContent);
        if (label && text.startsWith(label) && text.length > label.length) {
          if (addRow(label, text.slice(label.length).replace(/^\s*:\s*/, ''), context)) return;
        }
        const colon = text.indexOf(':');
        if (colon > 0 && colon < 45 && addRow(text.slice(0, colon), text.slice(colon + 1), context)) return;
        if (node.querySelector('img,a,video')) {
          notes.push(node.cloneNode(true));
        } else notes.push(text);
        return;
      }
      if (node.matches('img,video,a')) { notes.push(node.cloneNode(true)); return; }
      [...node.childNodes].forEach(child => {
        if (child.nodeType === 3 && clean(child.textContent)) notes.push(clean(child.textContent));
        else visit(child);
      });
    };
    [...source.children].forEach(visit);
    if (!handled) return;
    const all = [...rows.case, ...rows.movement, ...rows.water, ...rows.other];
    const find = predicate => all.find(predicate);
    const items = [
      [labels.diameter, find(r => /durchmesser|gehäusegröße|gehäusebreite/.test(normalize(r.original)))],
      [labels.movement, find(r => /uhrwerk|technische ausführung|^werk$/.test(normalize(r.original)) || (/uhrwerk/.test(normalize(r.context)) && /^typ$/i.test(r.original)))],
      [labels.strap, find(r => /armbandmaterial|bandmaterial/.test(normalize(r.original)) || (/armband/.test(normalize(r.context)) && /^material$/i.test(r.original)))],
      [labels.water, rows.water[0]]
    ].filter(([,row]) => row);
    const overview = root.querySelector('[data-watch-overview]');
    items.forEach(([label,row]) => {
      const item = document.createElement('div');
      const dt = document.createElement('dt');
      const dd = document.createElement('dd');
      dt.textContent = label; dd.textContent = row.value;
      item.append(dt,dd); overview.append(item);
    });
    const buildTable = (title, data) => {
      if (!data.length) return null;
      const section = document.createElement('section');
      const h = document.createElement('h3'); h.textContent = title;
      const table = document.createElement('table'); table.setAttribute('aria-label',title);
      const tbody = document.createElement('tbody');
      data.forEach(row => {
        const tr = document.createElement('tr');
        const th = document.createElement('th'); th.scope = 'row'; th.textContent = row.label;
        const td = document.createElement('td'); td.textContent = row.value;
        tr.append(th,td); tbody.append(tr);
      });
      table.append(tbody); section.append(h,table); return section;
    };
    const columns = root.querySelector('[data-watch-columns]');
    [buildTable(labels.case,rows.case),buildTable(labels.movementStrap,[...rows.movement,...rows.water])].filter(Boolean).forEach(section=>columns.append(section));
    const extra = root.querySelector('[data-watch-extra]');
    const extraDetails = root.querySelector('[data-watch-extra-details]');
    const other = buildTable(labels.other,rows.other);
    if (other) extra.append(other);
    [...new Set(notes)].forEach(note => { if (typeof note === 'string') {const p = document.createElement('p');p.textContent=note;extra.append(p);}else extra.append(note);});
    extraDetails.hidden = !extra.children.length;
    const fit = root.querySelector('[data-watch-fit]');
    const diameter = items.find(([label]) => label === labels.diameter);
    fit.hidden = !diameter;
    if (diameter) fit.querySelector('[data-watch-measure]').textContent = `${labels.diameter}: ${diameter[1].value}`;
    const intro = source.querySelector('.etp-product-intro');
    const product = root.closest('.product');
    const technical = root.querySelector('[data-watch-body]');
    const wrapper = root.closest('.etp-detail-description');
    const care = wrapper?.parentElement.querySelectorAll(':scope > .etp-watch-care, :scope > .etp-watch-water');
    if (product && technical) {
      const wide = document.createElement('div'); wide.className='etp-watch-wide';
      wide.append(technical); care?.forEach(node=>wide.append(node)); product.after(wide);
      const info = root.closest('.product__info-container');
      const introArea = info?.querySelector('.etp-intro');
      if (introArea && intro && clean(intro.textContent)) {
        const introText = clean(intro.querySelector('p')?.textContent || intro.textContent);
        const sentences = introText.match(/[^.!?]+[.!?]+(?:\s|$)|[^.!?]+$/g) || [introText];
        const p = document.createElement('p');p.textContent = sentences.slice(0,2).join(' ').trim();
        introArea.replaceChildren(p);
        if (sentences.length > 2) {
          const remainder = document.createElement('p');remainder.textContent=sentences.slice(2).join(' ').trim();extra.append(remainder);
          extraDetails.hidden=false;
        }
      }
      if (items.length) {
        if (introArea) introArea.after(overview);
        else info?.querySelector('.product__title')?.after(overview);
      }
      if (introArea && !source.querySelector('.etp-product-intro p')) introArea.hidden=true;
    }
    const details = technical.querySelector('[data-watch-technical]');
    details.hidden = !columns.children.length;
    const media = window.matchMedia('(min-width: 990px)');
    const update = () => { details.open = media.matches; };
    update(); media.addEventListener('change',update);
    source.hidden = true;
    technical.hidden = false;
    overview.hidden = !items.length;
    root.dataset.enhanced = 'true';
    if (product && wrapper) wrapper.hidden = true;
  };
  const init = scope => scope.querySelectorAll('[data-etp-watch]').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
